import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Observable, forkJoin } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { CustomerTerminalDetail } from 'src/app/models/entities/customer-terminal-detail';
import { CustomerTerminalMain } from 'src/app/models/entities/customer-terminal-main';
import { TerminalHistory } from 'src/app/models/entities/terminal-history';
import { VContract } from 'src/app/models/entities/v-contract';
import { VLogoCustomer } from 'src/app/models/entities/v-logo-customer';
import { VTerminal } from 'src/app/models/entities/v-terminal';
import { ContractService } from 'src/app/services/contract.service';
import { CustomerTerminalDetailService } from 'src/app/services/customer-terminal-detail.service';
import { CustomerTerminalMainService } from 'src/app/services/customer-terminal-main.service';
import { LogoService } from 'src/app/services/logo.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { TerminalHistoryService } from 'src/app/services/terminal-history.service';
import { TerminalService } from 'src/app/services/terminal.service';

@Component({
  selector: 'app-customer-terminal-add',
  templateUrl: './customer-terminal-add.component.html',
  styleUrls: ['./customer-terminal-add.component.css']
})
export class CustomerTerminalAddComponent implements OnInit {

  destroy$ = new Subject<void>();
  form: FormGroup;
  customers$: Observable<VLogoCustomer[]>;
  contracts$: Observable<VContract[]>;
  terminals$: Observable<VTerminal[]>;
  targetTerminals: VTerminal[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private contractService: ContractService,
    private logoService: LogoService,
    private terminalService: TerminalService,
    private customerTerminalMainService: CustomerTerminalMainService,
    private customerTerminalDetailService: CustomerTerminalDetailService,
    //private terminalHistoryService: TerminalHistoryService,
    private userService: NbsUserService
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getCustomers();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      groupCode: [""],
      groupName: [""],
      customerCode: [""],
      customerId: ["", Validators.required],
      contractId: ["", Validators.required],
      processDate: [new Date],
      isActive: true
    })
  }

  getCustomers() {
    this.customers$ = this.logoService.getCustomers().pipe(map(result => result.data));
  }

  getContracts(customerId: number) {
    this.contracts$ = this.contractService.getListByCustomerId(customerId).pipe(map(result => result.data));
  }

  getTerminals(portalId: number) {
    this.terminals$ = this.terminalService.getListByPortalId(portalId, false).pipe(map(result => result.data));
  }

  changeCustomer() {
    const customerId = this.form.get('customerId').value;
    this.contracts$ = null;
    this.terminals$ = null;
    this.targetTerminals = [];
    this.form.patchValue({ contractId: null });
    if (customerId != null) {
      this.getContracts(customerId);
    }
  }

  changeContract() {
    const contractId = this.form.get('contractId').value;
    this.terminals$ = null;
    this.targetTerminals = [];
    if (contractId != null) {
      this.contractService.getById(contractId).pipe(takeUntil(this.destroy$)).subscribe(result => {
        this.getTerminals(result.data.portalId);
      })
    }
  }

  add() {
    if (this.form.valid && this.targetTerminals.length > 0) {
      let customerTerminalMain: CustomerTerminalMain = this.form.getRawValue();
      customerTerminalMain.userId = this.userService.getUserId();

      this.logoService.getCustomerCodeById(customerTerminalMain.customerId).pipe(
        takeUntil(this.destroy$)
      ).subscribe(cus => {
        customerTerminalMain.customerCode = cus.data[0].code;
        this.customerTerminalMainService.add(customerTerminalMain).pipe(
          switchMap((res) => this.customerTerminalDetailService.addRange(this.createDetails(res.data.id)))
        ).pipe(takeUntil(this.destroy$)).subscribe(
          result => {
            this.terminalService.statusUpdateRangeTrue(this.targetTerminals).pipe(takeUntil(this.destroy$)).subscribe();
            this.toastrService.success(result.message, "İşlem başarılı.");
            this.router.navigateByUrl('/customer-terminal');
          },
          er => {
            this.toastrService.error("Aboneliğe ait kayıt zaten var!", "HATA!");
          }
        )
      })
    }
  }

  createDetails(customerTerminalMainId: number): CustomerTerminalDetail[] {
    let details: CustomerTerminalDetail[] = [];
    for (let i = 0; i < this.targetTerminals.length; i++) {
      let detail: CustomerTerminalDetail = {
        id: 0,
        customerTerminalMainId: customerTerminalMainId,
        terminalId: this.targetTerminals[i].id,
        isActive: true
      };
      details.push(detail);
    }
    return details;
  }

  ngOnDestroy(): void {
    this.destroy$.next;
  }

}
